import styled from 'styled-components'

import { colors } from 'shared/styles/colors'

export const Container = styled.div`
  position: relative;
  display: flex;
  height: calc(100vh);
  justify-content: space-evenly;
  flex-direction: column;
  align-items: center;
  background: ${colors.white};
`
